
import FaqList from "@/components/FaqList";
import PageTitle from "@/components/PageTitle";
import Breadcrumbs from "@/components/Breadcrumbs";

export default {
  components: {
    FaqList,
    PageTitle,
    Breadcrumbs
  }
};
